import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Header from './header';
import LeftSide from './left-side';
import RightSideHeader from './right-side/header';
import RightSide from './right-side';
import './style.scss';
// import { history } from 'admin/state/store';
import PageLoader from 'common/components/modules/page-loading'
import { history as storeHistory } from 'admin/state/store';

import {
   MENU_SEGMENT_KEY,
   PAGE_SEGMENT_KEY,
   SECTION_SEGMENT_KEY,
   CREATE_PAGE_SEGMENT_KEY,
   GLOBA_SEGMENT_KEY,
   getGlobalSettings,
   // DEFAULT_ACCESS,
   getSegmentType,
   addOrRemoveQueryParams,
   getSegmentStates,
   ABOUT_ME_SETTINGS,
} from 'admin/views/site-designer/data';
import {
   ConfirmationModal,
   AboutMeWarningInfoModal,
} from 'admin/views/site-designer/modules';
import { isEmpty, isEqual } from 'lodash';
import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';
import EmptyState from 'common/components/modules/empty-states';
import {
   prepearComponentForRenderSelector,
   rightSideSelector,
   savedDataSelector,
} from 'admin/state/modules/site-designer/selectors';
import {
   stateUpdateAction,
} from 'admin/state/modules/site-designer/actions';
import {
   onClickAddNewPageOperation as onAddNewPage,
   onSelectGlobalSettingsOperation as onSelectGlobalSettings,
   onSelectPageOperation as onSelectPage,
   onSelectPageSectionOperation as onSelectPageSection,
   goBackOperation as goBack,
   onPrepearComponentForRender,
} from 'admin/state/modules/site-designer/operations';
import { useSelector, useDispatch } from 'react-redux';

const DONT_SHOW_ABOUT_ME_WARNING_STORAGE_KEY = 'dont_show_site_design_aboute_me_warning';
const SiteDesigner = ({
   pages,
   pageSections,
   onReorderPages,
   onCreateNewPage,
   deletePage,
   toggleVisibilityPage,
   restorePage,
   publishDraftContent,
   fetchPublishDraftContent,
   rightSideFetching,
   leftSideFetching,
   updatePage,
   currentPage,
   setCurrentPage,
   fetchSaveAsDraft,
   onReorderSections,
   updateCurrentSectionAction,
   updatePageSectionsAction,
   currentSectionUuid,
   prepearAddNew,
   updateSection,
   deletePageSection,
   restorePageSection,
   toggleVisibilityPageSection,
   globalSettings,
   updateGlobalSettings,
   updateGlobalSettingsAction,
   reservGlobalSettings,
   restorGlobalSettingsAction,
   restorCurrenPageAction,
   restorPageSectionsAction,
   goTo,
   setCurrentSegment,
   currentSegment,
   navigateByQueryParams,
   reservPageSections,
}) => {
   const leftSideStates = getSegmentStates();
   const { getIsDarkMode } = useSiteGlobalSettingsHelper(globalSettings);

   const [desktopType, setDesktopType] = useState('desktop');
   const [isShowFullScreen, setIsShowFullScreen] = useState(false);
   const [hideWarningInfo, setHideWarningInfo] = useState(true);
   const [aboutMeInfoModal, setAboutMeInfoModal] = useState({ isOpen: false });
   const prepearComponentForRender = useSelector(prepearComponentForRenderSelector)
   const rightSide = useSelector(rightSideSelector)
   const savedData = useSelector(savedDataSelector)
   const dispatch = useDispatch()
   const unlisten = useRef(null);
   const nextRoute = useRef(null);
   const unblock = useRef(null);
   const [discardChangesModal, setDiscardChangesModal] = useState({
      isOpen: false,
      arg: [],
   })

   const onStateUpdateAction = (data) => {
      dispatch(stateUpdateAction(data))
   }
   useEffect(() => {
      const onBeforeunload = (e) => {
         if(!isEmpty(savedData)){
            e.preventDefault();
            e.returnValue = '';
         }
      }
      window.addEventListener('beforeunload', onBeforeunload)
      const historylisten = () => {
         unlisten.current = storeHistory.listen((location, action) => {
            if(location.pathname === '/site-designer'){
               if(['POP'].includes(action)){
                  navigateByQueryParams()
               }
            }
         });
      }
      const handleEndConcert = () => {
         unblock.current = storeHistory.block((targetLocation, action) => {
            if(!discardChangesModal?.isOpen && !isEmpty(savedData) && 'POP' === action){
               nextRoute.current = { targetLocation, action };
               setDiscardChangesModal({
                  isOpen: true,
                  arg: [],
                  leavePage: true,
               })
               return false;
            }
         });
      }

      historylisten();
      handleEndConcert();
      return () => {
         if(unlisten.current){
            unlisten.current();
         }
         if(unblock.current){
            unblock.current();
         }

         window.removeEventListener('beforeunload', onBeforeunload)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [savedData, discardChangesModal]);

   const discardChange = () => {
      if(currentSegment.type === SECTION_SEGMENT_KEY){
         if(currentSegment?.is_global_settings_section){
            restorGlobalSettingsAction();
            console.log('restor global settings')
         } else {
            restorPageSectionsAction()
            console.log('restor page Sections')
         }
      }
      if(currentSegment.type === PAGE_SEGMENT_KEY){
         restorCurrenPageAction()
         console.log('restorcurrent page')
      }
      onStateUpdateAction({ savedData: {} });
      if(discardChangesModal?.leavePage){
         setDiscardChangesModal({
            isOpen: false,
            arg: [],
         })
         if(unblock.current){
            unblock.current();
         }
         if(nextRoute.current?.targetLocation){
            if(nextRoute.current?.action === 'POP'){
               storeHistory.goBack();
            } else if(nextRoute.current?.action === 'REPLACE'){
               storeHistory.replace(nextRoute.current.targetLocation);
            } else {
               storeHistory.push(nextRoute.current.targetLocation);
            }
         }

         return
      }
      const type = discardChangesModal.arg?.[1] || MENU_SEGMENT_KEY;
      const item = discardChangesModal.arg?.[0];
      switch (type) {
         case MENU_SEGMENT_KEY: {
            dispatch(stateUpdateAction({
               currentSegment: leftSideStates[MENU_SEGMENT_KEY],
               currentPage: {},
               reservCurrentPage: {},
               currentSectionUuid: null,
               rightSide: null,
            }))
            break;
         }
         case PAGE_SEGMENT_KEY:{
            dispatch(onSelectPage(item))
            break;
         }
         case SECTION_SEGMENT_KEY:{

            if(item?.is_global){
               dispatch(onSelectGlobalSettings(item))
            } else {
               dispatch(onSelectPageSection(item))
            }
            break;
         }
         case 'go_back':{
            const currentType = discardChangesModal.arg?.[2];
            dispatch(goBack(currentType))
            break;
         }

         default:
            break;
      }
      setDiscardChangesModal({
         isOpen: false,
         arg: [],
      })
   }
   const checkHasSavedData = (arg, leavePage = false) => {
      if(!isEmpty(savedData)){
         setDiscardChangesModal({
            isOpen: true,
            arg,
            leavePage,
         })
         return true;
      }
      return false;
   }


   const getLeftSideList = (type) => {
      const listByKey = {
         [GLOBA_SEGMENT_KEY]: getGlobalSettings(),
         [MENU_SEGMENT_KEY]: pages,
         [CREATE_PAGE_SEGMENT_KEY]: getPageSectionList(null, CREATE_PAGE_SEGMENT_KEY),
         [PAGE_SEGMENT_KEY]: currentPage.sections,
      }
      return listByKey?.[type] || [];
   }

   const getCurentSectionsData = (uuid, type) => {
      const segmentType = type || getSegmentType(currentSegment, currentPage);
      const segmentSections = {
         [GLOBA_SEGMENT_KEY]: globalSettings,
         [PAGE_SEGMENT_KEY]: pageSections,
         [CREATE_PAGE_SEGMENT_KEY]: {},
      }
      let sections = segmentSections?.[segmentType] || [];
      return sections
   }

   const getPageSectionList = (uuid, type = null) => {
      let sections = getCurentSectionsData(uuid, type);
      if(!sections){
         return [];
      }
      let sectionsList = []
      Object.keys(sections).forEach((key) => {
         const elm = sections?.[key] || {};
         let name = leftSideStates?.[elm?.section_type]?.name || elm.title
         const sectionItem = {
            ...elm,
            ...leftSideStates?.[elm.section_type],
            type: SECTION_SEGMENT_KEY,
            uuid: key,
            name,
         }
         sectionsList = [
            ...sectionsList,
            sectionItem,
         ]
      })
      return sectionsList;
   }


   const onChangeSection = (name, value, isMeta, otherValue = {}) => {
      const segmentType = getSegmentType(currentSegment, currentPage);
      let data = {
         [name]: value,
      }
      switch (segmentType) {
         case PAGE_SEGMENT_KEY: {
            if('type' === name){
               const defaultData = leftSideStates?.[value]?.default_value;
               if(defaultData?.metas){
                  updatePageSectionsAction(currentSectionUuid, {
                     link_button_text: defaultData?.metas.link_button_text,
                     link_to: defaultData?.metas.link_to,
                  }, true)
               }
               setCurrentSegment({
                  ...currentSegment,
                  section_type: value,
               });
            }
            updatePageSectionsAction(currentSectionUuid, data, isMeta)
            if(isMeta){
               const oldMetas = savedData?.metas || {};
               if(name === 'collections' && 'object' === typeof value && 'count' in value){
                  let metavalue = { ...value };
                  delete metavalue.count;
                  onStateUpdateAction({ savedData: {
                     ...savedData,
                     metas: {
                        ...oldMetas,
                        [name]: metavalue,
                     },
                  } });


               } else {
                  onStateUpdateAction({ savedData: {
                     ...savedData,
                     metas: {
                        ...oldMetas,
                        ...data,
                     },
                  } });

               }
            } else {
               onStateUpdateAction({ savedData: {
                  ...savedData,
                  ...data,
               } });
            }
            break;
         }
         case CREATE_PAGE_SEGMENT_KEY: {
            // setNewPageData({
            //    ...newPageData,
            //    [sectionId]: {
            //       ...newPageData[sectionId],
            //       [name]: value,
            //    },
            // });
            break;
         }
         case GLOBA_SEGMENT_KEY: {
            updateGlobalSettingsAction(currentSegment.uuid, { ...data, ...otherValue })
            onStateUpdateAction({ savedData: {
               ...savedData,
               ...data,
               ...otherValue,
            } });

            break;
         }

         default:
            break;
      }
   }
   const onChangeData = (data) => {
      setCurrentPage(data);
      onStateUpdateAction({ savedData: {
         ...savedData,
         ...data,
      } });
   }


   const goToBack = (type) => {
      if(checkHasSavedData([null, 'go_back', type])){
         return
      }
      dispatch(goBack(type))
   }

   const addNewSection = (type, isGlobalSettings, callback) => {
      prepearAddNew(type, currentPage, (defaultValue, uuid) => {
         if(callback){
            callback()
         }
         dispatch(onSelectPageSection({ ...defaultValue, uuid }));
         onStateUpdateAction({ savedData: isGlobalSettings ? {} : { ...defaultValue } });
      })
   }

   const onSaveDraft = async () => {
      if(currentPage?.uuid && currentSegment.type === PAGE_SEGMENT_KEY){
         // SAVE AS DRAFT CURRENT PAGE UPDATES
         updatePage(currentPage.id, savedData)
         return;
      }

      if(currentSegment.type === CREATE_PAGE_SEGMENT_KEY){
         // SAVE AS DRAFT CREATE NEW PAGE
         onCreateNewPage(savedData, (page) => {
            addOrRemoveQueryParams(CREATE_PAGE_SEGMENT_KEY);
            onStateUpdateAction({ savedData: {} });
            const  currentSegmentData = {
               ...leftSideStates[PAGE_SEGMENT_KEY],
               uuid: page.uuid,
            }
            addOrRemoveQueryParams(PAGE_SEGMENT_KEY, page.uuid);
            setCurrentSegment(currentSegmentData);

         })
         return;
      }

      if(currentSegment.type === SECTION_SEGMENT_KEY){
         if(currentSegment?.is_global_settings_section){
            //  UPDATE GLOBAL SETTINGS SECTION

            Object.keys(savedData).forEach(key => {
               if(isEqual(savedData?.[key], reservGlobalSettings[currentSegment.uuid]?.[key])){
                  delete savedData[key]
               }
            });

            updateGlobalSettings(currentSegment.uuid, savedData, () => {
               onStateUpdateAction({ savedData: {} });
            });
            return;
         }
         // SAVE AS DRAFT UPDATE (OR CREATE) SECTION

         updateSection(currentPage, currentSectionUuid, savedData);
         return;
      }

      console.log('Save as draft Else case.....')
   }

   const selectPage = (page) => {
      if(checkHasSavedData([page, PAGE_SEGMENT_KEY])){
         return
      }
      dispatch(onSelectPage(page))
   }
   const selectPageSection = (item) => {
      if(checkHasSavedData([item, SECTION_SEGMENT_KEY])){
         return
      }
      dispatch(onSelectPageSection(item))
   }
   const selectGlobalSettings = (item) => {
      if(checkHasSavedData([item, SECTION_SEGMENT_KEY])){
         return
      }
      dispatch(onSelectGlobalSettings(item))
   }
   return (
      <>
         {
            aboutMeInfoModal?.isOpen && (
               <AboutMeWarningInfoModal
                  action={ dontShowAgain => {
                     if(aboutMeInfoModal?.action){
                        aboutMeInfoModal.action();
                     }
                     setAboutMeInfoModal({ isOpen: false, action: null });
                     if(dontShowAgain){
                        localStorage.setItem(DONT_SHOW_ABOUT_ME_WARNING_STORAGE_KEY, 1)
                     }
                  } }
                  onCloseModal={ () => {
                     // setAboutMeInfoModal({ isOpen: false, action: null });
                  } }
               />
            )
         }
         {
            discardChangesModal?.isOpen &&
            <ConfirmationModal
               title='Discard changes?'
               description='Changes you have made so far will not be saved'
               buttonText='Yes'
               icon='cancel'
               iconColor='error'
               onClose={ _ => {
                  setDiscardChangesModal({
                     isOpen: false,
                     arg: [],
                  })
               } }
               action={ discardChange }
            />
         }
         <Header
            pages={ pages }
            selectedPage={ currentPage }
            onSelectPage={ selectPage }
            onSelectGlobalSettings={ (settings) => selectGlobalSettings(settings) }
            publishDraftContent={ publishDraftContent }
            fetchPublishDraftContent={ fetchPublishDraftContent }
            currentSegment={ currentSegment }
            currentSectionUuid={ currentSectionUuid }
            goTo={ goTo }
         />
         {
            currentSegment && (
               <div className='flex w-full bg-grey-main pt-[61px] h-[100vh] overflow-hidden site-designer-container gap-6'>

                  <LeftSide
                     currentSectionsData={ currentSegment?.is_global_settings_section ? globalSettings : pageSections }
                     globalSettingsData={ globalSettings }
                     currentSegment={ currentSegment }
                     isFullScreen={ isShowFullScreen }
                     states={ leftSideStates }
                     list={ getLeftSideList(currentSegment.type) }
                     onChangeSegment={ (item, type) => {
                        if(PAGE_SEGMENT_KEY === type){
                           selectPage(item)
                           return // else select is page section
                        }
                        if(item.type === ABOUT_ME_SETTINGS.uuid && !localStorage.getItem(DONT_SHOW_ABOUT_ME_WARNING_STORAGE_KEY)){
                           setAboutMeInfoModal({ isOpen: true, action: () => selectPageSection(item) })
                           return;
                        }
                        selectPageSection(item)
                     } }
                     goToBack={ goToBack }
                     screenWidth={ 1025 }
                     isPrepearComponentForRender={ prepearComponentForRender.left }
                     onChangeSection={ onChangeSection }
                     onReorderPages={ onReorderPages }
                     onReorderSections={ onReorderSections }
                     onCreateNewPage={ onCreateNewPage }
                     deletePage={ deletePage }
                     toggleVisibilityPage={ toggleVisibilityPage }
                     restorePage={ restorePage }
                     fetching={ leftSideFetching }
                     updatePage={ updatePage }
                     setCurrentPage={ setCurrentPage }
                     currentPage={ currentPage }
                     onSaveDraft={ onSaveDraft }
                     onChangeData={ onChangeData }
                     fetchSaveAsDraft={ fetchSaveAsDraft }
                     updateCurrentSectionAction={ updateCurrentSectionAction }
                     updatePageSectionsAction={ updatePageSectionsAction }
                     addNewSection={ (type, isGlobalSettings, callback) => {
                        if(type === ABOUT_ME_SETTINGS.uuid && !localStorage.getItem(DONT_SHOW_ABOUT_ME_WARNING_STORAGE_KEY)){
                           setAboutMeInfoModal({ isOpen: true, action: () => addNewSection(type, isGlobalSettings, callback) })
                           return;
                        }
                        addNewSection(type, isGlobalSettings, callback)
                     } }
                     deleteSection={ deletePageSection }
                     restoreSection={ restorePageSection }
                     toggleVisibilitySection={ toggleVisibilityPageSection }
                     reservPageSections={ reservPageSections }
                     onPrepearComponentForRender={ (...arg) => dispatch(onPrepearComponentForRender(...arg)) }
                     onAddNewPage={ _ => dispatch(onAddNewPage()) }
                     onSelectGlobalSettings={ (settings) => selectGlobalSettings(settings) }
                  />

                  <div
                     className={ cx({
                        'flex flex-col mx-auto': true,
                        'w-[calc(100%-431px)]': !isShowFullScreen,
                        'w-full': isShowFullScreen,
                     }) }
                  >
                     {
                        !rightSideFetching && (
                           <>
                              <RightSideHeader
                                 setDesktopType={ setDesktopType }
                                 desktopType={ desktopType }
                                 setIsShowFullScreen={ _ => setIsShowFullScreen(!isShowFullScreen) }
                                 isShowFullScreen={ isShowFullScreen }
                                 hideWarningInfo={ hideWarningInfo }
                                 setHideWarningInfo={ _ => setHideWarningInfo(!hideWarningInfo) }
                              />

                              {
                                 rightSide && (
                                    <RightSide
                                       pageSections={ pageSections }
                                       onClickSection={ item => selectPageSection(item) }
                                       desktopType={ desktopType }
                                       isShowFullScreen={ isShowFullScreen }
                                       rightSide={ rightSide }
                                       isPrepearComponentForRender={ prepearComponentForRender.right }
                                       activeEditableSection={ currentSectionUuid }
                                       segmentType={ getSegmentType(currentSegment, currentPage) }
                                       globalSettings={ globalSettings }
                                       isDarkMode={ getIsDarkMode() }
                                    />
                                 )
                              }
                              {
                                 !rightSide && (
                                    <EmptyState
                                       noContentText='View/edit your site’s pages or create the new one'
                                       noContentTextClassName='font-medium text-secondary !mt-4'
                                       className='justify-start text-center'
                                       buttonText='Create new page'
                                       onAdd={ _ => dispatch(onAddNewPage())  }
                                       linkButtonText='More info on site designer'
                                       linkButtonIcon='attention-outline'
                                       onLinkClick={ () => {

                                       } }
                                       icon='desginer'
                                       iconColor='major-dark'
                                       iconFontSize='5xl'
                                       iconClass='w-18 h-18 flex item-center justify-bitween bg-secondary-12 rounded-full'
                                       buttonIconSize='extraLarge'
                                       buttonHeight='h-10'
                                    />
                                 )
                              }

                           </>
                        )
                     }
                     {
                        rightSideFetching && (
                           <PageLoader />
                        )
                     }
                  </div>
               </div>
            )
         }
      </>
   )
}

SiteDesigner.propTypes = {
   pages: PropTypes.array,
   pageSections: PropTypes.object,
   globalSettings: PropTypes.object,
   rightSideFetching: PropTypes.bool,
   fetchPublishDraftContent: PropTypes.bool,
   leftSideFetching: PropTypes.bool,
   // getPageById: PropTypes.func,
   updatePage: PropTypes.func,
   publishDraftContent: PropTypes.func,
   // getPageDifferentAccess: PropTypes.func,
   restorePage: PropTypes.func,
   toggleVisibilityPage: PropTypes.func,
   deletePage: PropTypes.func,
   onReorderPages: PropTypes.func,
   onReorderSections: PropTypes.func,
   onCreateNewPage: PropTypes.func,
   setCurrentPage: PropTypes.func,
   currentPage: PropTypes.object,
   fetchSaveAsDraft: PropTypes.bool,
   updateCurrentSectionAction: PropTypes.func,
   updatePageSectionsAction: PropTypes.func,
   currentSectionUuid: PropTypes.string,
   prepearAddNew: PropTypes.func,
   updateSection: PropTypes.func,
   deletePageSection: PropTypes.func,
   restorePageSection: PropTypes.func,
   toggleVisibilityPageSection: PropTypes.func,
   // getPageSections: PropTypes.func,
   updateGlobalSettings: PropTypes.func,
   updateGlobalSettingsAction: PropTypes.func,
   restorGlobalSettingsAction: PropTypes.func,
   restorPageSectionsAction: PropTypes.func,
   restorCurrenPageAction: PropTypes.func,
   goTo: PropTypes.func,
   reservGlobalSettings: PropTypes.object,
   currentSegment: PropTypes.object,
   setCurrentSegment: PropTypes.func,
   navigateByQueryParams: PropTypes.func,
   // goBack: PropTypes.func,
   reservPageSections: PropTypes.object,
}

export default SiteDesigner;
